module.exports = __webpack_public_path__ + "static/img/managementicon.a450cc24.png";